import FloorMap from "pages/FloorMap";
import Home from "pages/Home";
import LostItem from "pages/admin/LostItem";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Information from "pages/Information";
import Coupon from "pages/Coupon";
import AdminCoupon from "pages/admin/Coupon";
import Congestion from "pages/Congestion";
import Camera from "pages/admin/Camera";
import Login from "pages/Login";
import Signup from "pages/Signup";
import Admin from "pages/admin";
import LostChild from "pages/admin/lostChild";
import ShopEdit from "pages/admin/ShopEdit";
import HomeEdit from "pages/admin/HomeEdit";
import Shop from "pages/Shop";
import ShopList from "pages/ShopList";
import NotFound from "pages/NotFound";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/signup" element={<Signup />}></Route>
                <Route path="/coupon" element={<Coupon />}></Route>
                <Route path="/map" element={<FloorMap />}></Route>
                <Route path="/information" element={<Information />}></Route>
                <Route path="/congestion" element={<Congestion />}></Route>
                <Route path="/shop-list" element={<ShopList />}></Route>
                <Route path="/shop" element={<Shop />}></Route>
                <Route path="/admin" element={<Admin />}></Route>
                <Route path="/admin/lost-item" element={<LostItem />}></Route>
                <Route path="/admin/lost-child" element={<LostChild />}></Route>
                <Route path="/admin/shop-edit" element={<ShopEdit />}></Route>
                <Route path="/admin/home-edit" element={<HomeEdit />}></Route>
                <Route path="/admin/coupon" element={<AdminCoupon />}></Route>
                <Route path="/admin/camera" element={<Camera />}></Route>
                <Route path="*" element={<NotFound />}></Route>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
